<template>
  <v-footer class="ma-0 pa-0"
            height="auto">
    <div style="width:100%"
         class="ma-0 pa-0 black">
      <v-container>
        <v-row justify="center">
          <v-col v-for="(contentItem, i) in contentItems"
                 :key="`footer-content-item-${i}`"
                 md="4"
                 lg="3"
                 xl="2"
                 offset="0"
                 cols="6"
                 align-self="start"
                 class="text-md-left py-0 my-md-2"
                 :class="{'text-left':i % 2 === 1,'text-right':i % 2 === 0}">
            <v-card flat
                    class="py-0 my-md-2"
                    color="black">
              <v-card-text class="py-0 my-md-2"
                           :class="{
                'text-center': contentItem.isCenter,
                'white--text': true
              }">
                <v-row class="ongeoprimary--text subtitle-1 font-weight-bold">
                  <v-col>
                    <span v-html="contentItem.title"></span>
                  </v-col>
                </v-row>
                <div v-for="(item, j) in contentItem.subitems"
                     class="my-2 subtitle-2"
                     :key="`footer-content-item_subitem-${j}`">
                  <template v-if="item.br">
                    <br>
                  </template>
                  <template v-else>
                    <span v-if="item.url">
                      <a :target="contentItem.openInNewWindow ? '_blank' : '_self'"
                         rel="noreferrer"
                         class="white--text"
                         :href="item.url"
                         :aria-label="item.title">
                        <span v-html="item.title" />
                      </a>
                    </span>
                    <span v-else-if="item.to">
                      <router-link :to="item.to"
                                   class="white--text">
                        <span v-html="item.title" />
                      </router-link>
                    </span>
                    <span v-else-if="item.isButton">
                      <VueOnGeoButton :block="true"
                                      :text="item.title"
                                      :primary-color="item.color" />
                    </span>
                    <span class="grey--text"
                          v-html="item.title"
                          v-else />
                  </template>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-divider color="white" />
        <v-row justify="center">
          <p class="text-center mb-0 headline ongeoprimary--text">
            Platforma OnGeo:
            <span class="title">
              <a href="https://ongeo.pl/raporty/"
                 target="_blank"
				 rel="noreferrer"
                 title="Wszystkie dane o nieruchomości w jednym miejscu"
                 class="white--text">Raporty,</a>&nbsp;
              <a href="https://ongeo.pl/nieruchomosci/"
                 target="_blank"
				 rel="noreferrer"
                 title="Ogłoszenia nieruchomości na mapie"
                 class="white--text">Nieruchomości,</a>&nbsp;
              <a href="https://api.ongeo.pl/"
                 target="_blank"
				 rel="noreferrer"
                 title="Narzędzia deweloperskie oparte o komponent mapy i lokalizacji"
                 class="white--text">API,</a>&nbsp;
              <a href="https://agro.ongeo.pl/"
                 target="_blank"
				 rel="noreferrer"
                 title="Szacowanie szkód w rolnictwie"
                 class="white--text">Agro</a>&nbsp;
            </span>
          </p>
        </v-row>
        <v-divider color="white" />
        <v-row justify="center"
               class="py-3">
          <v-btn href="https://blog.ongeo.pl/"
                 target="_blank"
                 title="Blog OnGeo"
                 class="mx-2"
                 fab
                 small
                 color="#fdc600">
            <v-icon color="white">
              mdi-blogger
            </v-icon>
          </v-btn>
          <v-btn href="https://www.facebook.com/ongeopl/"
                 target="_blank"
                 title="Facebook OnGeo"
                 class="mx-2"
                 color="#3b5998"
                 small
                 fab>
            <v-icon color="white">
              mdi-facebook
            </v-icon>
          </v-btn>
          <v-btn title="Youtube OnGeo"
                 target="_blank"
                 href="https://www.youtube.com/channel/UCNf-BjzYTdQBWdLiTHP3_oA"
                 class="mx-2"
                 fab
                 small
                 color="#dd4b39">
            <v-icon color="white">
              mdi-youtube
            </v-icon>
          </v-btn>
          <v-btn title="Twitter OnGeo"
                 target="_blank"
                 href="https://twitter.com/OnGeoGeoportal"
                 class="mx-2"
                 fab
                 small
                 color="#55acee">
            <v-icon color="white">
              mdi-twitter
            </v-icon>
          </v-btn>
        </v-row>
      </v-container>
    </div>
  </v-footer>
</template>

<script>
import VueOnGeoButton from "./vue-ongeo-button.vue";
export default {
  name: "vue-ongeo-footer",
  components: {
    VueOnGeoButton
  },
  props: {
    contentItems: {
      type: Array,
      default: () => {
        return [];
      }
    }
  }
};
</script>